module.exports = __webpack_public_path__ + "img/error.de9ffb85.svg";